import { render } from "./BasePageTitle.vue?vue&type=template&id=6755cda4&lang=pug"
import script from "./BasePageTitle.vue?vue&type=script&lang=js"
export * from "./BasePageTitle.vue?vue&type=script&lang=js"

import "./BasePageTitle.vue?vue&type=style&index=0&id=6755cda4&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__